import listSaga from './listSaga'

const countriesSagas = [listSaga()]

export default countriesSagas
